import React, {useRef} from "react";
import {Nullable} from "../../../../../@typings/typings";
import {useKatex} from "../../../../../helpers/hooks/useKatex";
import {Grid, Typography} from "@mui/material";

interface QuestionRenderLatexProps {
    renderString: Nullable<string | string[]>;
    title: string;
    renderLatex?: (renderString: string | string[]) => string;
}

export default function QuestionRenderLatex({ renderString, title, renderLatex = (s) => s.toString() }: QuestionRenderLatexProps) {
    const displayRef = useRef<HTMLDivElement>(null);
    useKatex(displayRef, [renderString]);

    return (
        renderString
            ? (
                <Grid container direction={"column"}>
                    <Typography variant={"h6"}>{title}</Typography>
                    <Grid container item>
                        <Grid item xs={12} ref={displayRef} dangerouslySetInnerHTML={{ __html: renderLatex(renderString) }} />
                    </Grid>
                </Grid>
            )
            : null
    )
}